<template>
  <div class="widthFull mainBackground h-100 somatoline">
    <loading v-if="loadingState" />
    <div class="container dataContainer">
      <form class="pb-5" id="ibanInsert" @submit.prevent="ibanInsert">
        <div class="row justify-content-center mt-5 pb-5">
          <div class="col-md-6 mt-5 pt-5">
            <h2 class="uppercase darkBlue  mt-5">
              <b>Prima di poter procedere é necessario inserire l'iban</b>
            </h2>
            <small class="back-white center"
              >I dati inseriti serviranno per poter ricevere gli eventuali rimborsi a cui si ha accesso tramite le promozioni in piattaforma.</small
            ><br />
            <small class="back-white center"
              >Successivamente non sará possibile modificare i dati che si
              stanno inserendo in questo form.</small
            >
            <small class="back-white center"
              >Operazione richiesta solo al primo login.</small
            >
            <div class="group mt-5">
              <input
                type="text"
                class="form-control"
                v-model="accHolder"
                id="accHolder"
                name="accHolder"
                data-vv-as="Intestatario"
                v-validate="{ required: true, min: 5 }"
                :class="{
                  'is-invalid': errors.has('accHolder'),
                  valid: !!accHolder,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="accHolder"
                >Intestatario Iban</label
              >
              <div v-if="errors.has('accHolder')" class="invalid-feedback">
                {{ errors.first("accHolder") }}
              </div>
            </div>
            <div class="group">
              <input
                type="text"
                class="form-control"
                v-model="iban"
                id="iban"
                name="iban"
                data-vv-as="Iban"
                v-validate="{
                  required: true,
                  ibanItalian: true,
                  ibanControl: true,
                  min: 5,
                }"
                :class="{ 'is-invalid': errors.has('iban'), valid: !!iban }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="iban">Iban</label>
              <div v-if="errors.has('iban')" class="invalid-feedback">
                {{ errors.first("iban") }}
              </div>
            </div>
            <div class="center mt-5 mt-md-3 mb-md-0 mb-5 pb-5">
              <button class="btn btn-secondary btn-lg mr-md-5" tag="button">
                CONFERMA
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import { USER_REQUEST } from "actions/user";

export default {
  name: "account",
  components: {},
  data() {
    return {
      iban: "",
      accHolder: "",
      loadingState: false,
    };
  },
  methods: {
    ibanInsert: function (e) {
      var data = {
        iban: this.iban,
        accHolder: this.accHolder,
        userToken: this.userToken,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      this.$validator.validate().then((valid) => {
        if (valid && this.userToken) {
          this.loadingState = true;
          axios({
            url: process.env.ROOT_API + "api/insertField",
            data: { data },
            method: "POST",
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              this.loadingState = false;
							resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
							this.$track("ibanInsert", "ALL OK");
              if (resp.data) {
                this.$store
                  .dispatch(USER_REQUEST, this.userToken)
                  .then(() => {});
                this.showAlertSuccess(
                  "Hai correttamente inserito i dati relativi al tuo iban"
                );
              } else {
                this.showAlertError(err.response.data.message);
              }
            })
            .catch((err) => {
              resp.response.data = this.$decryptByAES(
                resp.response.data,
                process.env.CRYPTKEY
              );
              this.$track("ibanInsert", "ERROR");
              this.showAlertError(err.response.data.message);
            });
        }
      });
    },
    showAlertError(value) {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: value + " !",
        onClose: () => {
          window.location.reload();
        },
      });
    },
    showAlertSuccess(value) {
      // Use sweetalret2
      this.$swal({
        type: "success",
        html: value,
        showCancelButton: false,
        animation: false,
        onClose: () => {
          this.$router.push("/");
        },
      });
    },

    setProfileData: function () {
      this.company = this.profile.company;
      this.email = this.profile.email;
      this.userToken = this.profile.userToken;
      this.piva = this.profile.piva;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      if (this.profile.iban) {
        this.$router.push("/");
      }
    },
  },
  watch: {
    getProfile: function (val) {
      this.setProfileData();
    },
    phone: function (val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
  },
  mounted: function () {
    this.setProfileData();
  },

  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/iban/index.vue